import { Wifi, WifiOff } from 'lucide-react';
import { useFeedStore } from '@/stores/feedStore';
import { cn } from '@/lib/utils';

export function ConnectionStatus() {
  const { connected, error } = useFeedStore();

  return (
    <div className="flex items-center gap-2">
      <span
        className={cn(
          'relative flex h-2.5 w-2.5',
        )}
      >
        {connected && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-compliance-low opacity-75" />
        )}
        <span
          className={cn(
            'relative inline-flex h-2.5 w-2.5 rounded-full',
            connected ? 'bg-compliance-low' : 'bg-compliance-critical',
          )}
        />
      </span>

      {connected ? (
        <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Wifi className="h-3 w-3" />
          Live
        </span>
      ) : (
        <span className="flex items-center gap-1.5 text-xs text-compliance-critical">
          <WifiOff className="h-3 w-3" />
          {error ?? 'Disconnected'}
        </span>
      )}
    </div>
  );
}
